/** @format */

export const BACKEND_URL = process.env.REACT_APP_DEV_URL;
